<template>
  <div class="modal-advanced-settings">
    <h5 class="text-semibold">Configurações avançadas</h5>
    <div class="d-flex flex-column gap-3">
      <h5 class="text-dark-40">
        Receber confirmação de venda dos meios de pagamento:
      </h5>
      <div class="d-flex flex-column gap-3">
        <div class="d-flex align-items-center gap-2">
          <input
            class="input-radio"
            type="radio"
            v-model="form.payment_type"
            value="all"
          />
          <h5>Todos os meios de pagamento</h5>
        </div>
        <div class="d-flex align-items-center gap-2">
          <input
            class="input-radio"
            type="radio"
            v-model="form.payment_type"
            value="only_card"
          />
          <h5>Somente cartão de crédito</h5>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column gap-3">
      <h5 class="text-dark-40">
        Receber confirmação com o valor:
      </h5>
      <div class="d-flex flex-column gap-3">
        <div class="d-flex align-items-center gap-2">
          <input
            class="input-radio"
            type="radio"
            v-model="form.value_type"
            value="real_value"
          />
          <h5>Valor real da venda</h5>
        </div>
        <div class="d-flex align-items-center gap-2">
          <input
            class="input-radio"
            type="radio"
            v-model="form.value_type"
            value="custom_value"
          />
          <h5>Valor que eu definir</h5>
        </div>
      </div>
    </div>
    <div
      v-if="form.value_type === 'custom_value'"
      class="d-flex flex-column align-items-start gap-4"
    >
      <div
        v-for="(opt, i) in form.custom_value_config.value_by_method"
        :key="`method-value-${i}`"
        class="payment-methods"
      >
        <action-dispatcher action="product/getPaymentMethods">
          <snow-select
            class="select-payment-method"
            v-model="opt.payment_method"
            id="payment_method_v"
            label="Quando o pagamento for"
            :options="paymentMethods"
          />
        </action-dispatcher>
        <div class="value-buttons p-0">
          <snow-input
            v-model="opt.value"
            money
            class="w-100"
            label="Valor"
            id="value_payment_method"
            :money-config="{
              prefix: ''
            }"
          />
          <snow-button
            size="sm"
            class="remove-button"
            text="Excluir"
            @click="removeValueByMethod(i)"
          />
        </div>
      </div>
      <snow-button
        variant="gray"
        size="sm"
        text="Adicionar meio de pagamento"
        @click="addValueByMethod"
      />

      <action-dispatcher action="product/getCurrency" class="w-100">
        <snow-select
          v-model="form.custom_value_config.currency"
          id="payment_method_currency"
          label="Enviar valores na moeda"
          :options="currencies"
        />
      </action-dispatcher>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      advanced: false
    };
  },
  computed: {
    ...mapState("product", ["paymentMethods", "currencies"])
  },
  methods: {
    addValueByMethod() {
      this.form.custom_value_config.value_by_method.push({
        payment_method: "",
        value: ""
      });
    },
    removeValueByMethod(i) {
      this.form.custom_value_config.value_by_method.splice(i, 1);
    }
  }
};
</script>
<style lang="scss" scoped>
.modal-advanced-settings {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .input-radio:checked:after {
    padding: 0px 0px 2px 0px;
    background-color: var(--dark);
    font-size: 14px;
    color: var(--light);
  }

  .select-payment-method {
    height: 82px;
  }
  ::v-deep .snow-select .snow-select__container {
    height: 82px !important;
  }

  .payment-methods {
    width: 100%;
    display: flex;
    gap: 13px;

    @media screen and (max-width: 992px) {
      flex-direction: column;
    }

    .value-buttons {
      flex: 1;
      display: flex;
      align-items: center;
      gap: 13px;
      @media screen and (max-width: 992px) {
        flex-direction: column;
        align-items: flex-end;
        gap: 16px;
      }
      .remove-button {
        background-color: var(--red) !important;
      }
    }
  }
}
</style>
